function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "save"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21 6.586-3.586-3.586c-.579-.58-1.595-1-2.414-1h-10c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-10c0-.819-.421-1.835-1-2.414zm-11-2.586h4v2h-4zm6 16h-8v-3c0-.551.448-1 1-1h6c.552 0 1 .449 1 1zm4-1c0 .551-.448 1-1 1h-1v-3c0-1.654-1.346-3-3-3h-6c-1.654 0-3 1.346-3 3v3h-1c-.552 0-1-.449-1-1v-14c0-.551.448-1 1-1h3v3c0 .552.447 1 1 1h6c.553 0 1-.448 1-1v-2.586l3.586 3.586c.201.201.414.715.414 1z"
}));

var Svg099Save = function Svg099Save(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg099Save, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/099-save.24701ca6.svg";
export { ForwardRef as ReactComponent };